import React, { useEffect, useState } from 'react'
import { useAssociate, useCategory, useMenu, useOrderSummary, usePayment } from '../../contexts'
import { AlertBox } from '../../assets/styledComponents/AlertBox'
import { CategoriesOptions } from '../../components/organisms/CategoriesOptions'
import Constants from '../../assets/constants/constantsStepOne.json'
import { CouponService } from '../../services'
import { PlansOptions } from '../../components/organisms/PlansOptions'
import { StagesMenu } from '../../components/organisms/Menu'
import { Step } from '../../contexts/MenuContext'
import { SummaryDeliveryFee } from '../../components/molecules/SummaryDeliveryFee'
import parseQueryParams from '../../utils/parseQueryParams'
import styled from 'styled-components'
import { useLocation } from '@reach/router'
import { dispatchGlobalEvent, hasBegunEventAction } from '@shared/services/tracking'
import { graphql } from 'gatsby'
import CommonHead from '@shared/meta/CommonHead'
import { getAlternativeCheckoutRedirectURL } from '@checkout/utils/redirects'

export function Head() {
  const queryProps = getPropsFromQuery()
  const redirectURL = typeof document !== 'undefined' && getAlternativeCheckoutRedirectURL( document.referrer, queryProps )

  return (
    <CommonHead
      title="Associe-se e escolha sua caixinha | TAG Livros"
      description="Torne-se um associado e escolha sua caixinha preferida para receber, a cada mês, um livro surpresa. Conheça nossas opções e viva essa experiência!"
    >
      {redirectURL && (
        <meta
          httpEquiv="refresh"
          content={ `0; URL=${redirectURL}` }
        />
      )}
    </CommonHead>
  )
}

const Container = styled.div`
  background: ${props => props.theme.cores.cinza100};
  height: 100vh;

  .container__content {
    max-width: 1030px;
    margin: 0 auto;
  }

  .mobileDeliveryFee {
    display: flex;
    padding: 40px 24px;
  }


  @media(max-width: ${props => props.theme.mediaQuery.smallpc}) {
    > div {
      padding-bottom: 80px;
    }
  }
`

const Box = ( { 'data': { allStrapiGifts } } ) => {
  const location = useLocation()
  const { setUtm, utm } = useAssociate()
  const { setContextByQueryParams, findPlan, findCategoryByName } = useCategory()
  const { goToNextStep, setActiveStep } = useMenu()
  const { coupon, setCoupon } = useOrderSummary()
  const { paymentMethod } = usePayment()
  const [ isCouponInvalid, setIsCouponInvalid ] = useState( false )
  const [ displayPageContent, setDisplayPageContent ] = useState( false )
  const parsedParams = parseQueryParams( location.search )

  const getCoupon = async( code, recommendationCode, plan ) => {
    try {
      const couponCode = recommendationCode || code

      const response = await CouponService.get( {
        'code': couponCode,
        'isRecommendation': Boolean( recommendationCode ),
        'planId': plan?.id,
        paymentMethod,
      } )

      setCoupon( response, plan )
    } catch ( error ) {
      setIsCouponInvalid( true )
    }
  }

  useEffect( () => {
    setContextByQueryParams( parsedParams, setDisplayPageContent )
    setActiveStep( 0, { 'navigation': false } )

    const {
      cupom,
      'codigo_indicacao': codigoIndicacao,
      modalidade,
      categoria,
      origin,
      'utm_source': utmSource,
      'utm_medium': utmMedium,
      'utm_campaign': utmCampaign,
    } = parsedParams

    const hasBegunCheckout = hasBegunEventAction( 'begin_checkout' )

    if ( origin !== 'assine' && !hasBegunCheckout ) {
      const beginCheckoutUrl = categoria && modalidade ? '/identificacao' : '/escolha-sua-caixinha'

      dispatchGlobalEvent( 'Checkout', 'begin_checkout', beginCheckoutUrl )
    }

    if ( categoria && modalidade ) {
      goToNextStep( { 'activeStep': Step.CHOOSE_BOX } )
    }

    if ( cupom || codigoIndicacao ) {
      let plan

      if ( categoria && modalidade ) {
        const categoryId = findCategoryByName( categoria )
        plan = findPlan( categoryId, modalidade )
      }

      getCoupon( cupom, codigoIndicacao, plan )
    }

    if ( utmSource || utmMedium || utmCampaign ) {
      setUtm( {
        utmSource,
        utmMedium,
        utmCampaign,
      } )
    }
  }, [] )

  return displayPageContent && (
    <Container>
      <div className="container__content">
        <StagesMenu
          menuJustification="flex-start"
        />
        {coupon.code && location.search.match( /codigo_indicacao=/ui ) ? (
          <AlertBox type="success">
            { Constants.RECOMMENDATION_COUPON_SUCCESS_MESSAGE }
          </AlertBox>
        ) : isCouponInvalid && (
          <AlertBox type="error">
            { Constants.RECOMMENDATION_COUPON_ERROR_MESSAGE }
          </AlertBox>
        )}
        <CategoriesOptions />
        <PlansOptions gifts={ allStrapiGifts.nodes[ 0 ] } />
        <SummaryDeliveryFee isFirstStep={ true } />
      </div>
    </Container>
  )
}

function getPropsFromQuery() {
  if ( typeof location === 'undefined' ) {
    return null
  }

  const query = new URLSearchParams( location.search )
  const category = query.get( 'categoria' ) || null
  const plan = query.get( 'modalidade' ) || null

  return { category, plan }
}

export default Box

export const query = graphql`
{
  ...Gifts
}
`
